import { getValidatedCertificateAccessToken } from './sessionStorage.js';
import { base64toBlob } from './conversion.js';
import { trackActivity } from './custom-track-events.js';
import { CertificateTrackAction, TrackCategory } from '@pok/activity-metric-sdk';
import { getCertificatePdf, getValidatedEdciCertificate } from '@pok/image-store-sdk';
import { registerEvent } from './google-analytics.js';

const download = (dataUrl, extension, name) => {
    const d = document.createElement('a');
    d.href = dataUrl;
    d.download = `${name}.${extension}`;
    d.target = '_blank';
    d.click();
};

export const downloadEdciFile = (certificateId, encryptedImage, organizationId, onExpiredToken, organization) => {
    registerEvent('eml_download');
    return getValidatedEdciCertificate(
        import.meta.env.VITE_IMAGE_STORE_API,
        certificateId,
        getValidatedCertificateAccessToken(certificateId),
    )
        .then((base64) => base64toBlob(base64))
        .then((blob) => URL.createObjectURL(blob))
        .then((dataUrl) => download(dataUrl, 'jsonld', organization.name))
        .then(() =>
            trackActivity(
                TrackCategory.CERTIFICATE,
                CertificateTrackAction.DOWNLOAD_EDCI,
                certificateId,
                organizationId,
            ),
        )
        .catch(() => {
            onExpiredToken(certificateId, encryptedImage);
        });
};

export const downloadPdfFile = (
    certificateId,
    languageTag,
    encryptedImage,
    organizationId,
    onExpiredToken,
    organization,
) => {
    //TODO: ideally should be registered in backend
    registerEvent('pdf_download');
    return getCertificatePdf(
        import.meta.env.VITE_IMAGE_STORE_API,
        certificateId,
        languageTag,
        getValidatedCertificateAccessToken(certificateId),
    )
        .then((base64) => base64toBlob(base64))
        .then((blob) => URL.createObjectURL(blob))
        .then((dataUrl) => download(dataUrl, 'pdf', organization.name))
        .then(() =>
            trackActivity(
                TrackCategory.CERTIFICATE,
                CertificateTrackAction.DOWNLOAD_IMAGE,
                certificateId,
                organizationId,
            ),
        )
        .catch(() => {
            onExpiredToken(certificateId, encryptedImage);
        });
};
